<div #paypalMessage></div>